import { Injectable } from '@angular/core';
import { UrlService } from '../../../../shared/services/url/url.service';
import { HttpService } from '../../../../shared/services/http/http.service';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QualityControlService {
  constructor(
    private urlService: UrlService,
    private http: HttpService
  ) {}

  listCQTrades(params: { page: number; pageSize: number; tradeId?: string }) {
    const url = this.urlService.getUrl('RECERTIFICATION_TVF.listCQPendingTrades', {
      page: params.page,
      pageSize: params.pageSize,
      idTrade: params.tradeId || '',
    });
    return this.http.get(url, null).pipe(catchError((err) => throwError(err)));
  }

  disapprove(tradeId: string, reason: string) {
    const url = this.urlService.getUrl('RECERTIFICATION_TVF.disapproveCQ');
    return this.http.post(url, { tradeId, reason }).pipe(catchError((err) => throwError(err)));
  }

  approve(
    tradeId: string,
    questions?: Array<{ questionId: string; answerId: string; reasonId: string }>
  ) {
    const url = this.urlService.getUrl('RECERTIFICATION_TVF.approveCQ');
    return this.http.post(url, { tradeId, questions }).pipe(catchError((err) => throwError(err)));
  }

  checklistRepair(tradeId: string) {
    const url = this.urlService.getUrl('RECERTIFICATION_TVF.checklistCQ', {
      tradeId,
    });
    return this.http.get(url, null).pipe(catchError((err) => throwError(err)));
  }

  repairRecord(data: { realocation: string, value: number}) {
    const url = this.urlService.getUrl('RECERTIFICATION_TVF.repairCountSum');
    return this.http.post(url, data).pipe(catchError((err) => throwError(err)));
  }
}
